<template>
  <div class="commentShareRule">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>商品</el-breadcrumb-item>
      <el-breadcrumb-item>评价</el-breadcrumb-item>
      <el-breadcrumb-item>评价共享管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索区域 -->
    <div class="search-container">
      <el-form :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="关键词">
          <el-input
            v-model="queryForm.search_keyword"
            placeholder="规则名称/商品名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryForm.search_status" placeholder="请选择" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            align="right"
            unlink-panels
            @change="handleDateChange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div class="btn mg-t-10">
        <el-button type="primary" size="medium" @click="getList">查询</el-button>
        <el-button size="medium" @click="handleReset">清空</el-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <div class="dataTable">
      <div class="mg-b-20">
        <el-button type="primary" size="mini" @click="handleAdd">新建规则</el-button>
      </div>

      <el-table
        ref="multipleTable"
        :data="tableData.data"
        border
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column label="ID" width="80" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column label="规则名称" min-width="180">
          <template slot-scope="scope">
            <div class="rule-name">{{ scope.row.rule_name }}</div>
            <div class="rule-desc" v-if="scope.row.description">{{ scope.row.description }}</div>
          </template>
        </el-table-column>

        <el-table-column label="关联商品" min-width="280">
          <template slot-scope="scope">
            <div class="goods-list" v-if="scope.row.goods && scope.row.goods.length > 0">
              <el-tag
                v-for="(goods, idx) in scope.row.goods.slice(0, 3)"
                :key="idx"
                size="small"
                class="mg-r-5 mg-b-5"
              >
                {{ goods.goods_name }}
              </el-tag>
              <span v-if="scope.row.goods.length > 3" class="more-goods">
                等{{ scope.row.goods.length }}个商品
              </span>
            </div>
            <span v-else class="no-goods">暂无关联商品</span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="handleStatusChange(scope.row)"
              active-color="#13ce66"
              inactive-color="gray"
            ></el-switch>
          </template>
        </el-table-column>

        <el-table-column
          label="创建时间"
          prop="create_time"
          width="160"
          align="center"
        ></el-table-column>

        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" @click="handleViewGoods(scope.row)">查看商品</el-button>
            <el-button type="text" style="color: #f56c6c" @click="handleDelete(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        :total="tableData.total"
        :per_page="tableData.per_page"
        :current_page="tableData.current_page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>

    <!-- 查看商品弹窗 -->
    <el-dialog
      title="关联商品列表"
      :visible.sync="goodsDialogVisible"
      width="60%"
    >
      <el-table :data="currentRuleGoods" border max-height="400">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column label="商品名称" min-width="200">
          <template slot-scope="scope">
            <div class="goods-info">
              <span>{{ scope.row.goods ? scope.row.goods.name : scope.row.goods_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品UUID" min-width="280">
          <template slot-scope="scope">
            <span class="text-gray">{{ scope.row.goods_id }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="goodsDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pagination from '../../../components/pagination.vue'

export default {
  name: 'CommentShareRuleList',
  components: {
    pagination
  },
  data() {
    return {
      loading: false,
      queryForm: {
        search_keyword: '',
        search_status: '',
        search_start_time: '',
        search_end_time: ''
      },
      dateRange: [],
      tableData: {
        data: [],
        total: 0,
        per_page: 10,
        current_page: 1
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - start.getHours() * 60 * 60 * 1000 - start.getMinutes() * 60 * 1000 - start.getSeconds() * 1000 - start.getMilliseconds())
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      goodsDialogVisible: false,
      currentRuleGoods: []
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const params = {
          page_index: this.tableData.current_page,
          page_size: this.tableData.per_page,
          search_keyword: this.queryForm.search_keyword,
          search_status: this.queryForm.search_status,
          search_start_time: this.queryForm.search_start_time,
          search_end_time: this.queryForm.search_end_time
        }
        // 移除空值参数
        Object.keys(params).forEach(key => {
          if (params[key] === '' || params[key] === null || params[key] === undefined) {
            delete params[key]
          }
        })
        const result = await this.$api.commentShareRule.getList(params)
        this.tableData = {
          data: result.data || [],
          total: result.total || 0,
          per_page: result.per_page || 10,
          current_page: result.current_page || 1
        }
      } catch (error) {
        console.error(error)
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },

    handleDateChange(value) {
      if (value && value.length === 2) {
        this.queryForm.search_start_time = value[0]
        this.queryForm.search_end_time = value[1]
      } else {
        this.queryForm.search_start_time = ''
        this.queryForm.search_end_time = ''
      }
    },

    handleReset() {
      this.queryForm = {
        search_keyword: '',
        search_status: '',
        search_start_time: '',
        search_end_time: ''
      }
      this.dateRange = []
      this.tableData.current_page = 1
      this.getList()
    },

    handleAdd() {
      this.$router.push('/addCommentShareRule')
    },

    handleEdit(row) {
      this.$router.push({
        path: '/addCommentShareRule',
        query: { id: row.id }
      })
    },

    handleViewGoods(row) {
      this.currentRuleGoods = row.goods || []
      this.goodsDialogVisible = true
    },

    // 获取商品规格
    getGoodsSpecs(row) {
      if (row.goods && row.goods.specs) {
        return row.goods.specs
      }
      if (row.specs) {
        return row.specs
      }
      return []
    },

    // 格式化规格对象
    formatSpecObj(specObj) {
      if (!specObj) return '-'
      if (typeof specObj === 'string') return specObj
      if (typeof specObj === 'object') {
        const result = []
        for (const key in specObj) {
          if (/^\d+$/.test(key)) continue
          const value = specObj[key]
          if (value && typeof value !== 'object') {
            result.push(`${key}: ${value}`)
          }
        }
        return result.length > 0 ? result.join(', ') : '-'
      }
      return '-'
    },

    async handleStatusChange(row) {
      try {
        await this.$api.commentShareRule.updateStatus(row.id, { status: row.status })
        this.$message.success('状态修改成功')
      } catch (error) {
        console.error(error)
        this.$message.error('状态修改失败')
        // 恢复原状态
        row.status = row.status === 1 ? 0 : 1
      }
    },

    handleDelete(row) {
      this.$confirm(`确定删除规则"${row.rule_name}"吗？删除后该规则下的所有商品关联将被移除。`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$api.commentShareRule.delete(row.id)
          this.$message.success('删除成功')
          this.getList()
        } catch (error) {
          console.error(error)
          this.$message.error('删除失败')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    handleSizeChange(size) {
      this.tableData.per_page = size
      this.getList()
    },

    handleCurrentChange(page) {
      this.tableData.current_page = page
      this.getList()
    }
  }
}
</script>

<style scoped>
.commentShareRule {
  background: #f2f2f2;
  min-height: 100%;
}

.search-container {
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  font-size: 12px !important;
  margin-top: 20px;
}

.dataTable {
  padding: 20px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 20px;
}

.rule-name {
  font-weight: bold;
  color: #333;
}

.rule-desc {
  font-size: 12px;
  color: #999;
  margin-top: 5px;
}

.goods-list {
  max-height: 80px;
  overflow-y: auto;
}

.more-goods {
  color: #999;
  font-size: 12px;
}

.no-goods {
  color: #999;
  font-size: 12px;
}

.goods-info {
  display: flex;
  align-items: center;
}

>>> .el-button--text {
  padding: 5px 0px;
}

>>> .el-button--text span {
  font-size: 12px;
}

.spec-item {
  margin-bottom: 5px;
}

.spec-item:last-child {
  margin-bottom: 0;
}

.spec-tag {
  display: inline-block;
  background: #f4f4f5;
  color: #909399;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
}

.text-gray {
  color: #999;
  font-size: 12px;
}
</style>
